import { SyntheticEvent } from 'react';

import { GetLongPressCallback, GetLongPressResult, OsType } from './types';

export const parseBoolean = (value?: string | null): boolean =>
  ['true', '1', 'yes'].includes(value?.toLowerCase() || '');

export function getOS(): OsType | null {
  const { userAgent } = window.navigator;
  const { platform } = (window.navigator as any)?.userAgentData || {};
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os: OsType | null = null;

  if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}

export async function cacheImages(imageUrls: string[]): Promise<void> {
  const promises = imageUrls
    .filter(src => !!src)
    .map(src => {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.src = src;
        img.onload = resolve;
        img.onerror = reject;
      });
    });

  Promise.all(promises);
}

export function getLongPressEvents(
  callback: GetLongPressCallback,
  delay = 500,
): GetLongPressResult {
  let timeout: NodeJS.Timeout | null = null;

  const start = (event: SyntheticEvent<any, Event>) => {
    timeout = setTimeout(() => callback(event), delay);
  };

  const stop = () => timeout && window.clearTimeout(timeout);

  return {
    onTouchStart: start,
    onTouchEnd: stop,
    onTouchMove: stop,
  };
}

export async function sleep(milliseconds: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(resolve, milliseconds);
  });
}
